import { Component } from '@angular/core';

@Component({
  selector: 'app-form-textarea-demo',
  templateUrl: './form-textarea-demo.component.html',
})
export class FormTextareaDemoComponent {}
